
export enum BatteryManufacturer {
  ForseePower= 'ForseePower',
  Proterra= 'Proterra',
  SaftGroupeSAS= 'SaftGroupeSAS',
  BMZGroup= 'BMZGroup',
  VartaAG= 'VartaAG',
  CATL= 'CATL',
  BYDCompanyLtd= 'BYDCompanyLtd',
  LeclancheSA= 'LeclancheSA',
  ACC= 'ACC',
  InoBatAuto= 'InoBatAuto',
  Other= 'Other',

}